import { z } from "zod";

import {
  defaultFalseSchema,
  defaultEmptyStringSchema,
  defaultZeroSchema,
} from "./primitives";
import { catFormDataSchema } from "./cat-form-data.schema";
import { userFormDataSchema } from "./user-form-data.schema";
import { deliveryDataSchema } from "./delivery-data.schema";
import { subscriptionDataSchema } from "./subscription-data.schema";
import { viewStateSchema } from "./view-state.schema";

export const signupFlowStoreSchema = z
  .object({
    isStoreInitialised: defaultFalseSchema,
    versionMismatchDetected: defaultFalseSchema,
    cats: z.record(z.string(), catFormDataSchema).default({}),
    activeCatId: defaultEmptyStringSchema,
    user: z.preprocess((val) => val ?? {}, userFormDataSchema),
    delivery: z.preprocess((val) => val ?? {}, deliveryDataSchema),
    subscription: z.preprocess((val) => val ?? {}, subscriptionDataSchema),
    viewState: z.preprocess((val) => val ?? {}, viewStateSchema),
    isLoading: defaultFalseSchema,
    sufQuizVersion: defaultZeroSchema,
    savedAt: z.string().optional(),
  })
  .strip();

/* Persisted / validated signup-flow snapshot (post-parse, all defaults applied). */
export type TSignupFlowStoreData = z.infer<typeof signupFlowStoreSchema>;

/* Pre-parse shape: matches what the runtime store holds before hydration. */
export type TSignupFlowStoreInput = z.input<typeof signupFlowStoreSchema>;

/* Validates and normalises rehydrated signup-flow snapshots. */
export function parseSignupFlowPersistedSnapshot(raw: unknown) {
  return signupFlowStoreSchema.safeParse(raw);
}
